import { RestaurantContextProvider } from 'webReservations/context/RestaurantContext';
import { IsDiscoverable } from 'webReservations/restaurant/IsDiscoverable';

export const NewGuestLandingLayout = () => (
  <RestaurantContextProvider>
    <IsDiscoverable />
  </RestaurantContextProvider>
);
